import { useContext } from 'react'
import { useStore } from 'zustand'
import { StoreContext } from '../StoreProvider'

const hasUniqueKeys = (props, store) => {
  const propKeys = Object.keys(props)
  const selectorKeys = Object.keys(store)
  const set = new Set([...propKeys, ...selectorKeys])

  return set.size === propKeys.length + selectorKeys.length
}

export const withStore = selectors => Component => props => {
  const { store } = useContext(StoreContext)

  if (!store) throw new Error('Missing StoreContext.Provider in the tree')

  const zustandStore = useStore(store, selectors)

  if (!hasUniqueKeys(props, zustandStore)) {
    console.warn('One or more Zustand selectors conflict with components props')
  }

  return <Component {...props} {...zustandStore} />
}
